import { For, Show } from "solid-js";
import { completedReadinessItems } from "./briefReadiness";
import type { DeliveryBrief } from "./briefTypes";

export function BriefQueue(props: {
  briefs: DeliveryBrief[];
  selectedId: string | null;
  mapAvailable: boolean;
  websiteId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <aside class="brief-queue" aria-label="Work ready to brief">
      <header>
        <span class="signal-mini-kicker">Work ready to brief</span>
        <h2>Brief queue</h2>
        <p>One coherent delivery outcome per brief.</p>
      </header>
      <Show
        when={props.briefs.length > 0}
        fallback={
          <div class="brief-queue-empty">
            <strong>No supported work is ready to brief</strong>
            <p>
              Faro found no eligible issue or accepted Map change in this
              Preview session.
            </p>
          </div>
        }
      >
        <div class="brief-queue-list" role="listbox" aria-label="Briefs">
          <For each={props.briefs}>
            {(brief) => (
              <button
                type="button"
                role="option"
                class={`brief-queue-item${props.selectedId === brief.id ? " is-selected" : ""}`}
                aria-selected={props.selectedId === brief.id}
                onClick={() => props.onSelect(brief.id)}
              >
                <span>{brief.source.label}</span>
                <strong>{brief.title}</strong>
                <small>
                  {brief.pages.length > 0
                    ? `${brief.pages.length} ${brief.pages.length === 1 ? "page" : "pages"}`
                    : "Origin resource scope"}
                  {" / "}
                  {brief.status}
                </small>
                <i>{completedReadinessItems(brief)} of 6 input checks</i>
              </button>
            )}
          </For>
        </div>
      </Show>
      <Show when={!props.mapAvailable}>
        <div class="brief-map-empty">
          <span>No accepted Map change in this Preview session.</span>
          <a href={`/w/${props.websiteId}/map`}>Open Map</a>
        </div>
      </Show>
    </aside>
  );
}
